import { useEffect, useRef, useState } from "react";
import PropTypes from "prop-types";
import { useSelector } from "react-redux";

import TitleBarImg from "../../../../../../public/BP_resources/images/icon/litigation-icon-color.svg";
// import NotesPanel from "../../../../NotesPanelSection/NotesPanel";
import PanelActionBarComponent from "../../../../common/PanelActionBarComponent";
import CounselEditPopup from "../../../../DefendantPage/Counsel/popups/CounselEditPopup";
import ConfirmDeletePopup from "../../../../DefendantPage/DefandantMain/ConfirmDeletePopup";
import { useOpposingCounsel } from "../hooks/useOpposingCounsel";
// import ContactPanel from "./contact-panel";
// import CounselInformation from "./counsel-info";
import ContactPanelForTreatment from "../../../../TreatmentPage/components/ContactPanelForTreatment";
import InformationPanel from "../../../../common/InformationPanel";
// import NotesPanel from "../../../../NotesPanelSection/NotesPanel";
import { addClickRecord } from "../../../../../Utils/helper";
import TreatmentNotesSection from "../../../../TreatmentPage/NotesTreatmentSection";
import "../../../../common/RecordPanel.css";

function CounselMain({ object, handleFetchWitnesses, page, name = "" }) {
  const [counselEditModal, setCounselEditModal] = useState(false);
  const [activeTab, setActiveTab] = useState("counsel");
  const [isShowConfirmDelete, setIsShowConfirmDelete] = useState(false);
  const page_id_click_record = useSelector(
    (state) => state.page_id_click_record.page_id_click_record
  );
  const { deleteOpposingCounsel } = useOpposingCounsel();

  const handleDeleteShow = () => {
    setIsShowConfirmDelete(!isShowConfirmDelete);
    addClickRecord(999, page_id_click_record);
  };

  const handleCounselEditModal = (tab) => {
    setCounselEditModal(true);
    setActiveTab(tab);
  };

  const handleDeleteCounselSubmission = async () => {
    try {
      addClickRecord(999, page_id_click_record);
      const success = await deleteOpposingCounsel(object?.id);
      if (success) {
        handleFetchWitnesses();
        setIsShowConfirmDelete(false);
        setCounselEditModal(false);
      }
    } catch (error) {
      console.error("Error deleting counsel:", error);
    }
  };

  // const clientName =
  //   `${object?.for_client?.first_name || ""} ${object?.for_client?.last_name || ""}`.trim();
  const PanelGenereateButtons = [
    {
      iconClassName: "ic ic-15 ic-generate-document",
      buttonText: "Letter",
      className: "p-l-6 p-r-5",
      style: { height: "25px" },
      onClick: () => {
        addClickRecord(999, page_id_click_record);
      },
    },
  ];
  const EmploymentButtonsConfig2 = [
    {
      id: "generate-document-button",
      iconClassName: "ic ic-19 ic-avatar has-avatar-icon has-cover-img m-l-5",
      imgSrc: "",

      imgClassName: "ic ic-19 m-r-5",
      buttonText: "9/20/25 10:30 AM",
      className: "p-l-6 p-r-5",
      style: { height: "25px" },
      onHover: () => {},
      onMouseLeave: () => {
        // setHoveredIndex(null);
      },
      onClick: () => {
        // setHoveredIndex(true);
      },
    },
  ];
  const [height, setHeight] = useState(null);
  const counselRef = useRef(null);

  useEffect(() => {
    if (counselRef.current) {
      setHeight(counselRef.current.clientHeight);
    }
  }, [counselRef]);
  const type = `${object?.counsel_type?.name || ""}`;
  return (
    <>
      <div className="report record-panel mb-0">
        <PanelActionBarComponent
          compact
          panelIconSrc={TitleBarImg}
          instanceForName="Counsel"
          page_id={64}
          id={object?.id}
          type={type || ""}
          name={name || ""}
          forInstanceName={name || "Unknown Client"}
        />
        <div
          className="record-panel-body d-flex flex-wrap"
          style={{
            gap: "5px",
          }}
        >
          <div ref={counselRef} className="leins-container-four m-b-5">
            <div
              className="min-w-260px-client"
              style={
                {
                  // maxHeight: "160px",
                }
              }
            >
              <ContactPanelForTreatment
                id={object.opposingcounselcontact?.id}
                panel_name={"Law Firm"}
                className="m-b-0"
                pageName={"client"}
                websiteURL={object.opposingcounselcontact?.website}
                name={object.opposingcounselcontact?.name}
                address1={object.opposingcounselcontact?.address1}
                address2={object.opposingcounselcontact?.address2}
                email={object.opposingcounselcontact?.email}
                city={object.opposingcounselcontact?.city}
                state={object.opposingcounselcontact?.state}
                zip_code={object.opposingcounselcontact?.zip}
                phone_number={object.opposingcounselcontact?.phone_number}
                fax_number={object.opposingcounselcontact?.fax}
                buttonData={PanelGenereateButtons}
                genrate_doc_address={0}
                templateDropdownId={0}
                templatePageId={64}
                onSelectObject={() => {
                  addClickRecord(999, page_id_click_record);
                  handleCounselEditModal("counsel");
                }}
              />
            </div>
            <div
              style={
                {
                  // maxHeight: "160px",
                }
              }
              className="min-w-260px-client"
            >
              <ContactPanelForTreatment
                name={`${object?.supervisor?.first_name || ""} ${object?.supervisor?.last_name || ""}`}
                className="m-b-0"
                panel_name={"Supervising Attorney"}
                pageName="Defendants"
                phone_number={object?.supervisor?.phone_number}
                fax_number={object?.supervisor?.fax}
                email={object?.supervisor?.email}
                address1={object?.supervisor?.address1}
                address2={object?.supervisor?.address2}
                city={object?.supervisor?.city}
                state={object?.supervisor?.state}
                zip_code={object?.supervisor?.zip}
                ext={object?.supervisor?.phone_ext}
                websiteURL={object?.supervisor?.website}
                genrate_doc_address={0}
                templateDropdownId={0}
                templatePageId={64}
                buttonData={PanelGenereateButtons}
                onSelectObject={() => handleCounselEditModal("supervisor")}
              />
            </div>
            <div
              style={
                {
                  // maxHeight: "160px",
                }
              }
              className="min-w-260px-client"
            >
              <ContactPanelForTreatment
                id={object.opposingattorney?.id}
                panel_name={"Main Attorney"}
                className="m-b-0"
                pageName={"client"}
                websiteURL={object.opposingattorney?.website}
                name={`${object.opposingattorney?.first_name || ""} ${object.opposingattorney?.last_name || ""}`}
                address1={object.opposingattorney?.address1}
                address2={object.opposingattorney?.address2}
                email={object.opposingattorney?.email}
                city={object.opposingattorney?.city}
                state={object.opposingattorney?.state}
                zip_code={object.opposingattorney?.zip}
                phone_number={object.opposingattorney?.phone_number}
                fax_number={object.opposingattorney?.fax}
                buttonData={PanelGenereateButtons}
                genrate_doc_address={0}
                templateDropdownId={0}
                templatePageId={64}
                onSelectObject={() => {
                  addClickRecord(999, page_id_click_record);
                  handleCounselEditModal("attorney");
                }}
              />
            </div>
            <div
              style={
                {
                  // maxHeight: "160px",
                }
              }
              className="min-w-260px-client"
            >
              <InformationPanel
                id={object?.id}
                panel_name="Information"
                pageName="defendant_counsel"
                className="m-b-0"
                data={[
                  { label: "Type", value: object?.counsel_type?.name },
                  { label: "File", value: object?.file_number },
                  // { label: "Original Lien", value: currencyFormat(object?.orignal_lien) },
                  // { label: "Final Lien", value: currencyFormat(object?.final_lien) },
                ]}
                onSelectReport={() => {
                  addClickRecord(999, page_id_click_record);
                  handleCounselEditModal("information");
                }}
                hasBtn={true}
                buttonData={EmploymentButtonsConfig2}
                panelClassName="mt-0"
                // defaultLength={7}
              />
            </div>
          </div>

          <div
            className=""
            style={{
              flex: 1,
              minHeight: "160px",
              paddingRight: "0px",
              scrollbarWidth: "none",
              minWidth: "min(400px, 100%)",
              maxHeight: `${height}px`,
            }}
          >
            <p className="menu-bar-style columnsTitle text-center">Notes</p>
            <TreatmentNotesSection
              entity_type={"Counsel"}
              record_id={object?.id}
              module={"Counsel"}
              notesName={"Counsel"}
              instanceFor="Defendants" //to show height with respect to defendants page
              pagePanels={4}
            />
          </div>
        </div>
        {/* <div className="flex-row d-flex" style={{ gap: "0px" }}>
          <div
            className="row m-t-5 g-0 equal-column-wrapper position-relative panels-direction-column insurance-col-panels opposing-counsel-attorney-new"
            style={{
              // gap: "5px",
              maxHeight: "max-content",
            }}
          >
             <ContactPanel
              contact={object?.opposingcounselcontact}
              title="Opposing Counsel"
              onEdit={() => handleCounselEditModal("counsel")}
              className="opposing-counsel-panel"
            /> 

             <ContactPanel
              contact={object?.opposingattorney}
              title="Opposing Attorney"
              onEdit={() => handleCounselEditModal("attorney")}
              className="opposing-attorney-panel"
            /> 
            
            <CounselInformation
              counselTypeName={object?.counsel_type?.name}
              opposingCounselFileNumber={object?.file_number}
              handleCounselEditModal={() => handleCounselEditModal("information")}
            /> 
            <InformationPanel
              id={object?.id}
              panel_name="Counsel Information"
              data={[
                { label: "Type", value: object?.counsel_type?.name },
                { label: "File", value: object?.file_number },
              ]}
              onSelectReport={() => {
                addClickRecord(999, page_id_click_record);
                handleCounselEditModal("information");
              }}
              hasBtn={false}
              panelClassName="mt-0"
              defaultLength={7}
            />
          </div>

          <div
            className=""
            style={{
              flex: 1,
              minHeight: "160px",
              paddingRight: "0px",
              scrollbarWidth: "none",
              marginTop: "5px",
            }}
          >
            <p
                            className="menu-bar-style columnsTitle text-center"
            >
              Notes
            </p>

            <TreatmentNotesSection record_id={object?.id} module="Counsel" />
          </div> 
          <NotesPanel record_id={object?.id} module="Counsel" pagePanels={3} />
        </div> */}
      </div>

      {counselEditModal && (
        <CounselEditPopup
          show={counselEditModal}
          handleClose={() => {
            addClickRecord(999, page_id_click_record);
            setCounselEditModal(false);
          }}
          activeTab={activeTab}
          pageName={page}
          opposingcounsel={object}
          handleFacthDefendants={handleFetchWitnesses}
          onShowDeleteConfirmPopup={handleDeleteShow}
        />
      )}
      {isShowConfirmDelete && (
        <ConfirmDeletePopup
          entity="Counsel"
          handleClose={handleDeleteShow}
          handleDeleteSubmission={handleDeleteCounselSubmission}
        />
      )}
    </>
  );
}

CounselMain.propTypes = {
  object: PropTypes.shape({
    id: PropTypes.number,
    for_client: PropTypes.shape({
      first_name: PropTypes.string,
      last_name: PropTypes.string,
    }),
    opposingcounselcontact: PropTypes.object,
    opposingattorney: PropTypes.object,
    counsel_type: PropTypes.shape({
      name: PropTypes.string,
    }),
    file_number: PropTypes.string,
  }),
  handleFetchWitnesses: PropTypes.func.isRequired,
  page: PropTypes.string,
};

export default CounselMain;
